import React from 'react';
import useRandom from './useRandom';

export interface ICaptcha {
    value: string;
    matched: boolean;
    reload: () => void;
    handleMatch: (valueToMatch: string) => void;    
}

export function useCaptcha () : ICaptcha {
    const random = useRandom();

    const generate = React.useCallback(() => {
        return random.generateLetters(3, { upperCase: true });
    }, [random]);

    const [value, setValue] = React.useState(() => generate());
    const [matched, setMatched] = React.useState(false);

    const reload = React.useCallback(() => {
        setValue(generate());
    }, [generate]);

    const handleMatch = React.useCallback((valueToMatch: string) => {
        const valueToMatchUpperCase = (valueToMatch || "").toUpperCase();
        setMatched(valueToMatchUpperCase === value);
    }, [value]);

    return React.useMemo(() => ({
        value, matched, reload, handleMatch
    }), [reload, matched, value, handleMatch]);
}